var a = Math.expm1,
  t = Math.exp,
  e = !a || a(10) > 22025.465794806718 || 22025.465794806718 > a(10) || -.00000000000000002 != a(-.00000000000000002) ? function (a) {
    var e = +a;
    return 0 == e ? e : e > -.000001 && e < 1e-6 ? e + e * e / 2 : t(e) - 1;
  } : a;
export { e as m };